<template>
  <MainNavigation/>
</template>

<script>
import MainNavigation from '@/components/MainNavigation.vue'

export default {
  name: 'Menu',
  components: {
    MainNavigation
  }
}
</script>

<style scoped lang="scss">

</style>
